var _defs, _rect, _rect2, _rect3, _circle, _circle2, _path, _path2, _line, _line2, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.51 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#555;stroke-linejoin:round;stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 61.51,
    height: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.76,
    y: 5,
    width: 22,
    height: 12,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.76,
    y: 22.76,
    width: 8.49,
    height: 8.49,
    transform: "translate(-9.55 29.12) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49.76,
    cy: 43,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30.76,
    cy: 43,
    r: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,27H15a4,4,0,0,0-4,4v6",
    transform: "translate(0.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,27h9a4,4,0,0,1,4,4v6",
    transform: "translate(0.76)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.76,
    y1: 17,
    x2: 30.76,
    y2: 21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.76,
    y1: 33,
    x2: 30.76,
    y2: 37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.76,
    y: 37,
    width: 12,
    height: 12,
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,49v2a4,4,0,0,1-4,4H15a4,4,0,0,1-4-4V49",
    transform: "translate(0.76)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons4);
export default __webpack_public_path__ + "static/media/icons4.9e4e3151faa1e1d52886dcf115e059b2.svg";
export { ForwardRef as ReactComponent };